import React from "react";
import { useTranslation } from "react-i18next";

import { DiabetesTypeOptionId } from "@/constants";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "../../Question";
import { MultipleChoiceQuestion } from "../core";

const QUESTION_ID = "diabetesType";

declare module "@/contexts" {
  interface SurveyAnswers {
    diabetesType?: DiabetesTypeOptionId;
  }
}

const DiabetesTypeQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: DiabetesTypeOptionId.TYPE2, text: t("diabetesType.options.type2") },
    { id: DiabetesTypeOptionId.TYPE1, text: t("diabetesType.options.type1") },
    {
      id: DiabetesTypeOptionId.GESTATIONAL,
      text: t("diabetesType.options.gestational"),
    },
    { id: DiabetesTypeOptionId.UNSURE, text: t("diabetesType.options.unsure") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("diabetesType.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_DIABETES_TYPE: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["WEIGHT", "DPP", "DIABETES_LIFESTYLE", "MED", "NMPBA"],
  shouldShowQuestion: ({ surveyAnswers: { diabetesDiagnosis } }) =>
    diabetesDiagnosis === "yes",
  component: DiabetesTypeQuestion,
};

export default DiabetesTypeQuestion;
